export const RegularExp = {
  // PHONE:
  //   /(^(?!\+.*\(.*\).*--.*$)(?!\+.*\(.*\).*-$)([+0-9]{1}[0-9]{1}[(0-9]{2}[()0-9]{1}[0-9]{1}([)0-9]?)?([0-9]?)?([)-0-9]?)?([-0-9]{0,7})?([0-9]{0,3})?)$)|(^[0-9]{1,4}$)/,
  PHONE: /[\d+\-() ]+/g,
  EMAIL: /\S+@\S+\.[a-z]+/i,
  PIN: /^([0-9]{4})$/,
};

export const CodeFormType = {
  REGISTRATION: `registration`,
  LOG_IN: `log-in`,
};
